import {useQuery, useQueryClient, useMutation} from "react-query";
import {Id, toast} from 'react-toastify';
import API from './utils/api';
import {
    IdTypePaginator,
    CreateIdTypeDto,
    QueryIdTypeDto,
    SearchIdTypeDto,
    UpdateIdTypeDto,
    IdentityDocumentType
} from "../models/identity-document-type.dto";
import ENDPOINTS from "./utils/endpoints";

export function useGetIdType(options?: QueryIdTypeDto) {
    const url = ENDPOINTS.PROCESSING_COMPANY.ID_TYPE.GET;
    const request = (options: QueryIdTypeDto) => API.ProcessingCompanyAPI.getIdType(options);

    const { data, isLoading, error, refetch } = useQuery<IdTypePaginator, Error>(
        [url, options],
        ({ queryKey, pageParam }) => request(Object.assign({}, queryKey[1], pageParam)),
        {...API.Handlers.pageParamOption}
    );

    return { data, isLoading, error, refetch }
}

export function useGetIdTypeSearch() {

    return useMutation(
        (options?: SearchIdTypeDto) => API.ProcessingCompanyAPI.searchIdType(options),
        {
            onSuccess: () => {
                //toast.success('Record created successfully');
            },
            onError: API.Handlers.onErrorHandler,
        },
    );
}

export function useGetIdTypeById(id: number) {
    const url = ENDPOINTS.PROCESSING_COMPANY.ID_TYPE.DETAIL;
    const request = API.ProcessingCompanyAPI.getIdTypeById(id);

    const {data, isLoading, error} = useQuery<{ data:IdentityDocumentType }, Error>(
        [url, id],
        (() => request),
        {
            enabled: !!(id),
        }
    );

    return {
        data: data,
        isLoading,
        error,
    };
}

export function useCreateIdType() {
    const queryClient = useQueryClient();

    return useMutation(
        ({payload}: {payload: CreateIdTypeDto}) => API.ProcessingCompanyAPI.createIdType(payload),
        {
            onSuccess: () => {
                toast.success('Record created successfully');
                queryClient.invalidateQueries(ENDPOINTS.PROCESSING_COMPANY.ID_TYPE.GET);
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}

export function useUpdateIdType() {
    const queryClient = useQueryClient();

    return useMutation(
        ({payload, id}: {payload: UpdateIdTypeDto, id: number}) => API.ProcessingCompanyAPI.updateIdType(id, payload),
        {
            onSuccess: () => {
                toast.success('Record updated successfully');
                queryClient.invalidateQueries(ENDPOINTS.PROCESSING_COMPANY.ID_TYPE.GET);
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}

export function useDeleteIdType() {

    return useMutation(
        ({ id}: {id: number}) => API.ProcessingCompanyAPI.deleteIdType(id),
        {
            onSuccess: () => {
                toast.success('Record deleted successfully');
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}